import { findCandidatesLabel } from '@/utils/array/find';
import { calcIncludingTax } from '@/utils/calc/tax';
import { RFP_PAYMENT_OPTIONS, RFP_PAYMENT_OPTION_TEN_PERCENT, } from '@/utils/constants/rfp/paymentOption';
/**
 * 支払い方法のテキスト表示（複数）
 * @returns {string}
 */
export const getPaymentOptionsText = ({ budget, paymentOption, }) => {
    const joinText = 'または';
    /** 成果報酬のみか */
    const isOnlyAchievementReward = paymentOption.length === 1 &&
        paymentOption[0] === RFP_PAYMENT_OPTION_TEN_PERCENT.value;
    // 成果報酬のみの場合
    if (isOnlyAchievementReward) {
        return RFP_PAYMENT_OPTION_TEN_PERCENT.label;
    }
    /** 成果報酬が含まれるか */
    const hasAchievementReward = paymentOption.some((option) => option === RFP_PAYMENT_OPTION_TEN_PERCENT.value);
    /** 成果報酬以外の options */
    const optionExceptAchievementReward = paymentOption.filter((option) => option !== RFP_PAYMENT_OPTION_TEN_PERCENT.value);
    const labels = optionExceptAchievementReward
        .map((option) => findCandidatesLabel(RFP_PAYMENT_OPTIONS, option))
        .filter((option) => option)
        .join(joinText);
    const annotation = `（${!budget ? 'ご提案金額' : '予算上限額'}に対してのご請求）`;
    const baseText = `${labels}${annotation}`;
    return hasAchievementReward
        ? `${baseText}${joinText}${RFP_PAYMENT_OPTION_TEN_PERCENT.label}`
        : baseText;
};
/**
 * 支払い金額の取得
 * @returns {string}
 */
export const getPaymentFee = ({ budget, paymentOption, price: rawPrice, }) => {
    const { feeRate } = RFP_PAYMENT_OPTIONS.find((option) => option.value === paymentOption) || {};
    const price = budget || rawPrice;
    if (!feeRate || !price) {
        return '';
    }
    const priceExcludingTax = Math.floor(price * 10000 * feeRate);
    return calcIncludingTax(priceExcludingTax).toLocaleString();
};
